import * as d3scale from 'd3-scale';
import {
  PieChart as RechartPieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend as RechartLegend,
} from 'recharts';
import { useMemo } from 'react';
import { useTheme } from '@captivateiq/quotient';
import { PieChartContainer } from './PieChartContainer.styles';
import { PieChartProps } from '../../types';
import { Legend } from './Legend';
import { formatNumber } from '../../utils/chartUtils';

export const PieChart = ({ data, dataKeys, onClick, nameKey, format }: PieChartProps) => {
  const theme = useTheme();
  const brandPrimary100 = theme.palette.primary[100];
  const brandPrimary900 = theme.palette.primary[900];
  const colorScale = useMemo(() => {
    const min = 0;
    const max = data.length;
    return d3scale.scaleLinear([min, max], [brandPrimary100, brandPrimary900]);
  }, [data, brandPrimary100, brandPrimary900]);

  return (
    <PieChartContainer data-testid="pie-chart">
      <ResponsiveContainer key={data.length}>
        <RechartPieChart onMouseEnter={() => {}}>
          <Pie data={data} dataKey={dataKeys[0]} nameKey={nameKey} onClick={onClick}>
            {data.map((entry, index) => {
              const color = colorScale(index);
              return <Cell fill={color} key={`cell-${entry[nameKey]}`} />;
            })}
          </Pie>
          <Tooltip formatter={(value: string | number) => (format ? formatNumber({ value, format }) : value)} />
          <RechartLegend align="right" content={<Legend />} layout="vertical" verticalAlign="middle" />
        </RechartPieChart>
      </ResponsiveContainer>
    </PieChartContainer>
  );
};
